import type { FunctionComponent } from 'react';
import { NavLink } from 'react-router';

import { Anchor } from '@mantine/core';

export type InternalNavLinkProps = {
  label: string;
  src: string;
};

export const InternalNavLink: FunctionComponent<InternalNavLinkProps> = ({ label, src }) => (
  <Anchor
    variant="link-inverse-text-base"
    to={src}
    component={NavLink}
    underline="never"
    visibleFrom="md"
    end
  >
    {label}
  </Anchor>
);
